import { useTranslation } from 'react-i18next';
import { EntityDirectorySelectFilter } from '../shared/entityDirectory/EntityDirectorySelectFilter';
import { CustomerType } from '@texas/api/endpoints/customersApi';

interface CustomerTypeFilterProps {
  value?: CustomerType;
  onChange: (value?: CustomerType) => void;
}

export function CustomerTypeFilter({
  value,
  onChange,
}: CustomerTypeFilterProps) {
  const { t } = useTranslation();

  return (
    <EntityDirectorySelectFilter
      options={[
        { label: t('general.brand'), value: CustomerType.Brand },
        { label: t('general.vendor'), value: CustomerType.Vendor },
      ]}
      placeholder={t('brandsDirectory.allTypes')}
      value={value}
      onChange={(selectedValue) => onChange(selectedValue ?? undefined)}
    />
  );
}
